import React from "react";

export const LabelZoneIndicator = ({ btnText }) => {
	return (
		<div className="fixed w-full flex justify-center items-start top-[13px] md:top-8">
			<label className="md:w-[418px]  md:h-[60px] w-[303px] h-[35px] gradiantBlueClient  flex justify-center  items-center rounded-lg text-white font-semibold text-sm md:text-2xl">
				{btnText}
			</label>
		</div>
	);
};
